import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';

const tripleaughtdesignSizes = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '2XL',
  '3XL',
  "0 (Women's)",
  "2 (Women's)",
  "4 (Women's)",
  "6 (Women's)",
  "8 (Women's)",
  "10 (Women's)",
  "12 (Women's)",
  "14 (Women's)",
  "28 (Men's, Shorts Only)",
  "30 (Men's, Shorts Only)",
  "32 (Men's, Shorts Only)",
  "34 (Men's, Shorts Only)",
  "36 (Men's, Shorts Only)",
  "38 (Men's, Shorts Only)",
  "40 (Men's, Shorts Only)",
  "42 (Men's, Shorts Only)",
  '28x30',
  '30x30',
  '30x32',
  '30x34',
  '32x30',
  '32x32',
  '32x34',
  '34x30',
  '34x32',
  '34x34',
  '36x30',
  '36x32',
  '36x34',
  '38x30',
  '38x32',
  '38x34',
  '40x30',
  '40x32',
  '7 Mens',
  '7.5 Mens',
  '8 Mens',
  '8.5 Mens',
  '9 Mens',
  '9.5 Mens',
  '10 Mens',
  '10.5 Mens',
  '11 Mens',
  '11.5 Mens',
  '12 Mens',
  '13 Mens',
  'One Size',
];

export const tripleaughtdesignShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: tripleaughtdesignSizes }),
  ],
};
